import React from 'react';

// Components
import PaidBreakOptions from 'scenes/Time/components/PaidBreakOptions';
// @ts-ignore
import TableCellRenderDropdown from '../TableCellRenderDropdown';

export class PaidBreakTableCellRenderDropdown extends React.PureComponent {
    render(): React.ReactElement {
        return (
            <PaidBreakOptions>
                <TableCellRenderDropdown {...this.props} />
            </PaidBreakOptions>
        );
    }
}

export default PaidBreakTableCellRenderDropdown;
